import { useEffect, useMemo, useState } from "react"
import { iconWhiteFans } from "../../assets"
import FanSpeedInfoTooltip, { FanSpeedInfoTooltipProps } from "../FanSpeedInfoTooltip"




export type FanButtonProps = {
  style?: React.CSSProperties
  fanSpeedMode?: "MEDIUM" | "HIGH" | "LOW" | "MIN"
  fanSwitch?: boolean
  onFanSpeed?(value: FanButtonProps['fanSpeedMode']): void
  onFanSwitch?(value: FanButtonProps['fanSwitch']): void
}
const FanButton = (props: FanButtonProps) => {



  const [fanSpeedInfoTooltipState, setFanSpeedInfoTooltipState] = useState<FanSpeedInfoTooltipProps>()

  const [show, setShow] = useState(false)

  useEffect(() => {

    setFanSpeedInfoTooltipState({ isOpen: show, fanSpeedMode: props.fanSpeedMode || 'HIGH' })

  }, [show, props.fanSpeedMode]);

  const onFanSpeed = (value: FanButtonProps['fanSpeedMode']) => {
    props.onFanSpeed && props.onFanSpeed(value)
  }

  const onFanSwitch = (value: FanButtonProps['fanSwitch']) => {
    props.onFanSwitch && props.onFanSwitch(value)
  }



  const datalise = useMemo(() => {

    type SpeedData = {
      title: string
      value: FanButtonProps['fanSpeedMode']
      type: 'speed'
    }

    type SwitchData = {
      title: string
      value: FanButtonProps['fanSwitch']
      type: 'switch'
    }


    const data: (SpeedData | SwitchData)[] = [
      { title: 'HIGH', value: 'HIGH', type: 'speed' },
      { title: 'MEDIUM', value: 'MEDIUM', type: 'speed' },
      { title: 'LOW', value: 'LOW', type: 'speed' },
      { title: 'MIN', value: 'MIN', type: 'speed' },
    ]

    return data
  }, [props.fanSwitch])



  return (
    <>

      {show && (
        <div
          onClick={(e) => {
            e.stopPropagation(); // 阻止事件冒泡到父元素
            setShow(false)
          }}
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            zIndex: 10,
          }}
        />
      )}


      <div
        onClick={() => setShow(!show)}
        className="bg-quickStartPrimaryBgColor"

        style={{
          borderRadius: 50,
          marginLeft: 16,
          height: 50,
          width: 50,
        }}
      >
        <img
          style={{
            padding: 5,
            height: 50,
            width: 50,
            opacity: show ? 0.3 : 1
          }}
          src={iconWhiteFans}
        />
        {show && (
          <div
            className="flex"
            style={{
              position: 'absolute',
              backgroundColor: '#EF8100',
              zIndex: 10000,
              left: 225,
              top: 55,
              padding: 5,
              borderRadius: 20,
              borderWidth: 4,
              borderColor: 'white',
            }}
          >
            {datalise.map((item, index) => {

              const pressDown = item.type === 'speed'
                ? item.value === props.fanSpeedMode
                  ? true
                  : false
                : item.type === 'switch'
                  ? item.value ? true : false
                  : false

              return (
                <div

                  onClick={(e) => {
                    e.stopPropagation(); // 阻止事件冒泡到父元素
                    switch (item.type) {
                      case 'speed': {
                        onFanSpeed(item.value)
                      }
                        break
                      case 'switch': {
                        onFanSwitch(!item.value)
                      }
                        break
                    }
                  }}

                  className={`flex ${pressDown ? 'bg-quickStartPrimaryBgColor' : ''}`}
                  key={index}
                  style={{
                    borderRadius: 50,
                    height: 60,
                    width: 60,
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginLeft: index === 0 ? 0 : 10,
                    justifyContent: 'center',

                    boxShadow: pressDown
                      ? "inset 4px 4px 4px rgba(0, 0, 0, 0.25)"
                      : "inset 4px 4px 4px rgba(0, 0, 0, 0.0)"
                  }}
                >
                  <img
                    style={{
                      height: 45,
                      width: 45,
                    }}
                    src={iconWhiteFans}
                  />
                  <span
                    style={{
                      fontSize: 8,
                      color: 'white',
                      fontWeight: 700,
                      marginTop: -3,
                    }}
                  >{item.title}</span>

                </div>

              )

            })}
          </div>
        )}
      </div>

      {fanSpeedInfoTooltipState && (
        <FanSpeedInfoTooltip
          {...fanSpeedInfoTooltipState}
          style={{
          }}
        />
      )}


    </>

  );
}

export default FanButton;
